import { useLocation } from 'react-router-dom';

import { ADMIN_ROUTE_PATH, ADMIN_ROUTE_RELATIVE_PATH } from '@/administration/constants/adminRoutePaths';

const FOOTER_HIDDEN_ROUTES = [
  new RegExp(`^${ADMIN_ROUTE_PATH.JOURNEYS}/\\d+/${ADMIN_ROUTE_RELATIVE_PATH.JOURNEY_EDIT_LEARNINGS}$`),
  new RegExp(
    `^${ADMIN_ROUTE_PATH.JOURNEYS}/\\d+/${ADMIN_ROUTE_RELATIVE_PATH.JOURNEY_EDIT_LEARNINGS.replace('/*', '')}/sections/\\d+$`,
  ),
  new RegExp(`^${ADMIN_ROUTE_PATH.JOURNEYS}/\\d+/${ADMIN_ROUTE_RELATIVE_PATH.JOURNEY_EDIT_CERTIFICATE}$`),
];

/**
 * Custom hook to check if the footer should be hidden for the current route
 * @returns true if footer should be hidden, false otherwise
 */
export const useFooterVisibility = (): boolean => {
  const location = useLocation();
  return FOOTER_HIDDEN_ROUTES.some((regex) => regex.test(location.pathname));
};
